import seedrandom from "seedrandom";

export const generateRandomString = (inputText) => {
  const alphabet =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const rng = seedrandom(inputText);

  let randomString = "";

  for (let i = 0; i < inputText?.length + 20; i++) {
    const randomIndex = Math.floor(rng() * alphabet?.length);
    randomString += alphabet[randomIndex];
  }

  return randomString;
};

export const generateRandomStringforMap = () => {
  const alphanumericChars = "abcdefghijklmnopqrstuvwxyz0123456789";
  let randomString = "";
  const length = 10;

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * alphanumericChars?.length);
    randomString += alphanumericChars.charAt(randomIndex);
  }

  return randomString;
};

export const generateColor = (text) => {
  const randomst = generateRandomString(text);
  const cancat = text?.replace(" ", "") + randomst;
  const hashCode = (s) => {
    let h = 0;
    for (let i = 0; i < s?.length; i++) {
      h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
    }
    return h;
  };

  const hash = hashCode(cancat);

  const redComponent = (hash & 0xff0000) >> 16;
  const greenComponent = (hash & 0x00ff00) >> 16;
  const blueComponent = hash & 0x0000ff;

  const color1 = `#${redComponent.toString(16).padStart(2, "0")}${greenComponent
    .toString(16)
    .padStart(2, "0")}${blueComponent.toString(16).padStart(2, "0")}`;

  return color1;
};

export const stringAvatar = (name) => {
  if (name) {
    if (
      name.trimStart().trimEnd().includes(" ") &&
      name.split(" ")[1]?.length > 1
    ) {
      return {
        children: `${name.split(" ")[0][0]}${
          name.split(" ")[1][0]
        }`.toUpperCase(),
      };
    } else {
      return {
        children: `${name[0]}${name[1] ? name[1] : ""}`.toUpperCase(),
      };
    }
  } else {
    return {
      children: "",
    };
  }
};

export const getInitialName = (name) => {
  if (name) {
    if (name.includes(" ")) {
      return `${name.split(" ")[0][0]} ${name.split(" ")[1][0]}`;
    } else {
      return `${name[0]}${name[1]}`;
    }
  }
};

export const splitFirstLetter = (name) => {
  let new_name = name
    ?.split(" ")
    .map((val) => val?.at(0)?.toUpperCase())
    .join("");
  return new_name;
};
